import { useEffect } from 'react';
import { StyledEngineProvider } from '@mui/material';
import { ThemeProvider, agronodTheme } from '@agronod/mui-components';
import { AuthProvider } from 'oidc-react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { auth_config } from './config';
import { AuthLifecycle } from './components/AuthLifecycle';
import Router from './components/Router';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // 403 bär affärsregler (15-dagarsregeln, roll) – omförsök hjälper inte.
      retry: false,
      refetchOnWindowFocus: false,
    },
  },
});

const App = () => {
  useEffect(() => {
    // Handle errors that we cannot control in an error boundary (wrong auth
    // state etc.) — same pattern as b2b-konto-web/datadelning-web.
    const handleUnhandledRejection = (event: any) => {
      console.error('Unhandled promise rejection caught:', event.reason);

      if (
        event.reason &&
        event.reason.message?.includes('No matching state found')
      ) {
        // Redirect to Keycloak login page if the token is expired
        window.location.href = '/';
      }
    };

    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener(
        'unhandledrejection',
        handleUnhandledRejection,
      );
    };
  }, []);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider options={agronodTheme}>
        <AuthProvider {...auth_config}>
          <AuthLifecycle />
          <QueryClientProvider client={queryClient}>
            <Router />
          </QueryClientProvider>
        </AuthProvider>
      </ThemeProvider>
    </StyledEngineProvider>
  );
};

export default App;
